import {FormControl, FormHelperText, Input, InputLabel} from "@material-ui/core"
import React from "react"

/**
 * Input that handles the specification of a person's document number.
 *
 * @param documentNumber: {String} The currently selected document number.
 * @param documentType: {String} The currently selected document type.
 * @param documentNumberError: {String} The current document number error (if any).
 * @param documentNumberMinLength: {Number} A minimum length that the document number must exceed.
 * @param documentNumberMaxLength: {Number} A minimum length that the document number must not exceed.
 * @param classes: {Object} Contains the JSS classes to configure the visuals of the input.
 * @param label: {String} The string to use when labeling the input.
 * @param tabIndex: {Number} Represents the order in the tab strokes.
 * @param id: {String} The unique identifier to put the input.
 * @param preventWrongKeysForDocumentNumber: {Function} A method that evaluates whether the pressed key can be accepted
 * into the document number or not.
 * @param changeDocumentNumber: {Function} A function to execute when the value has changed somehow.
 */
const DocumentNumberInput = ({
                                 documentNumber,
                                 documentType,
                                 documentNumberError,
                                 documentNumberMinLength = 7,
                                 documentNumberMaxLength = 8,
                                 classes = {},
                                 label = "Número",
                                 tabIndex = 1,
                                 id = "documentNumber",
                                 preventWrongKeysForDocumentNumber = (event, documentType) => null,
                                 changeDocumentNumber = (event, shouldValidate) => null,
                             }) => (

    <FormControl className={classes.formControl}
                 fullWidth={true} error={documentNumber !== null && documentNumberError !== ""}
                 aria-describedby="documentNumberError">
        <InputLabel htmlFor="documentNumber">{label}</InputLabel>

        <Input id="documentNumber"
               onKeyDown={event => preventWrongKeysForDocumentNumber(event, documentType)}
               onChange={event => changeDocumentNumber(event, true)}
               inputProps={{
                   maxLength: documentNumberMaxLength,
                   minLength: documentNumberMinLength,
                   autoComplete: 'off',
                   spellCheck: "false",
                   tabIndex,
                   id
               }}
               onPaste={event => event.preventDefault()}
               onDrop={event => event.preventDefault()}
               value={documentNumber}/>

        <FormHelperText id="documentNumberError">{documentNumberError}</FormHelperText>
    </FormControl>

)

export default DocumentNumberInput
